import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.profiling_history"))),
      ]),
      _c("actions-component", {
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { outlined: "", dense: "" },
                    on: { click: _vm.getRecords },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("mdi-refresh"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("botones.boton_update"))),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.openTableModal },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-add"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                  ],
                  1
                ),
                _c(
                  VTooltip,
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-1 btn-inca-secondary",
                                    attrs: { outlined: "", dense: "" },
                                    on: { click: _vm.onEnableFilter },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm.filterEnabled
                                  ? _c(VIcon, { attrs: { small: "" } }, [
                                      _vm._v("mdi-filter-off-outline"),
                                    ])
                                  : _vm._e(),
                                !_vm.filterEnabled
                                  ? _c(VIcon, { attrs: { small: "" } }, [
                                      _vm._v("mdi-filter-outline"),
                                    ])
                                  : _vm._e(),
                                _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClass },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "table-inca",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.items,
                    "hide-default-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.creationTime",
                      fn: function (data) {
                        return [
                          data.item.creationTime.seconds
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("timestampShortFormatDate")(
                                      " " + data.item.creationTime.seconds + " "
                                    )
                                  )
                                ),
                              ])
                            : _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("stringShortFormatDate")(
                                      " " + data.item.creationTime + " "
                                    )
                                  )
                                ),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "item.finishTime",
                      fn: function (data) {
                        return [
                          data.item.finishTime !== null &&
                          data.item.finishTime.seconds == undefined
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("stringLongFormatDate")(
                                      " " + data.item.finishTime + " "
                                    )
                                  )
                                ),
                              ])
                            : data.item.finishTime !== null &&
                              data.item.finishTime.seconds
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("timestampLongFormatDate")(
                                      " " + data.item.finishTime.seconds + " "
                                    )
                                  )
                                ),
                              ])
                            : _c("div", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: "item.status",
                      fn: function (data) {
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b({}, "div", attrs, false),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              _vm._s(
                                                " " + data.item.status + " "
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(" " + data.item.status_desc + " ")
                                ),
                              ]),
                            ]
                          ),
                          data.item.status === "PENDING" ||
                          data.item.status === "EXECUTING"
                            ? _c(VProgressCircular, {
                                attrs: {
                                  indeterminate: "",
                                  size: 20,
                                  color: "primary",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function (data) {
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "", attach: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.viewDetail(
                                                      data.item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_c(VIcon, [_vm._v("icon-view")])],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Ver Perfilamiento")])]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "", attach: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        data.item.status === "DONE" ||
                                        data.item.status === "PREPARED" ||
                                        data.item.status === "ERROR"
                                          ? _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editProfiling(
                                                          data.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("icon-edit"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Editar Perfilamiento")])]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "", attach: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        data.item.status === "DONE" ||
                                        data.item.status === "PREPARED" ||
                                        data.item.status === "ERROR"
                                          ? _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.executeDetail(
                                                          data.item,
                                                          "CURRENT",
                                                          "EXECUTING"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("mdi-arrow-right"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Ejecutar Perfilamiento")])]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "", attach: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        data.item.status === "DONE"
                                          ? _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.executeDetail(
                                                          data.item,
                                                          "NEW",
                                                          "EXECUTING"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("icon-renew"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Re execute profiling")])]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "", attach: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        data.item.status === "ERROR"
                                          ? _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      icon: "",
                                                      color: "red",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.executeError(
                                                          data.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("icon-renew"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Execute after error")])]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filterEnabled
          ? _c(
              "div",
              {
                staticClass:
                  "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2",
              },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    label: _vm.translate(
                                      "data_management.label.project"
                                    ),
                                    placeholder: _vm.translate(
                                      "data_management.placeholder.project"
                                    ),
                                    items: _vm.projects[_vm.userDomain],
                                  },
                                  model: {
                                    value: _vm.tableReference.project,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.tableReference,
                                        "project",
                                        $$v
                                      )
                                    },
                                    expression: "tableReference.project",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(VTextField, {
                              attrs: {
                                outlined: "",
                                dense: "",
                                label: _vm.translate(
                                  "data_management.label.dataset"
                                ),
                                placeholder: _vm.translate(
                                  "data_management.placeholder.dataset"
                                ),
                              },
                              model: {
                                value: _vm.tableReference.bigquery_dataset,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tableReference,
                                    "bigquery_dataset",
                                    $$v
                                  )
                                },
                                expression: "tableReference.bigquery_dataset",
                              },
                            }),
                            _c(VTextField, {
                              attrs: {
                                outlined: "",
                                dense: "",
                                label: _vm.translate(
                                  "data_management.label.table"
                                ),
                                placeholder: _vm.translate(
                                  "data_management.placeholder.table"
                                ),
                              },
                              model: {
                                value: _vm.tableReference.bigquery_table,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tableReference,
                                    "bigquery_table",
                                    $$v
                                  )
                                },
                                expression: "tableReference.bigquery_table",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "text-right", attrs: { cols: "12" } },
                          [
                            _c(
                              VBtn,
                              {
                                staticClass: "default mr-1",
                                attrs: { outlined: "" },
                                on: { click: _vm.onCleanSearch },
                              },
                              [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "primary",
                                on: { click: _vm.onSearch },
                              },
                              [_vm._v(_vm._s(_vm.$t("btns.search")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("pagination-firestore", {
        key: _vm.key_pagination,
        attrs: { pagination: _vm.pagination },
        on: { changePagina: _vm.changePage },
      }),
      _c(
        "DialogsComponent",
        {
          ref: _vm.MODAL_NAME_PROFILING_VIEW,
          attrs: { title: _vm.modalTitle(_vm.item), width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("history-item", {
                ref: _vm.MODAL_NAME_PROFILING_VIEW + "_body",
                attrs: { item: _vm.item, readonly: true },
                on: {
                  closeModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_PROFILING_VIEW].onClose()
                  },
                  changeTab: _vm.tabFlagFunction,
                },
              }),
            ],
            1
          ),
          _vm.tabFlag
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_NAME_PROFILING_VIEW + "_body"
                          ].$refs.table_result.openModal()
                        },
                      },
                    },
                    [
                      _c(VIcon, [_vm._v("icon-send")]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_guardar"))),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: _vm.MODAL_NAME_PROFILING_EDIT,
          attrs: { title: _vm.$t("frases.edit_profiling"), width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-profiling", {
                ref: _vm.MODAL_NAME_PROFILING_EDIT + "_body",
                attrs: {
                  item: _vm.item,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.UPDATE,
                  queryPreviousProfiling: false,
                },
                on: {
                  cancel: _vm.closeEditProfiling,
                  submit: _vm.closeEditProfiling,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_NAME_PROFILING_EDIT + "_body"
                      ].onSubmit()
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-send")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_guardar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: _vm.MODAL_TABLE_CONFIG,
          attrs: { title: _vm.texts.create, width: 600 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("query-table-profiling-component", {
                ref: _vm.MODAL_TABLE_CONFIG + "_body",
                attrs: {
                  projectListDict: _vm.projectListDict,
                  domainList: _vm.domainList,
                },
                on: { submitNewItem: _vm.submitNewItem },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_TABLE_CONFIG + "_body"].onSubmit()
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-send")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_confirmar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: _vm.MODAL_NEW_PROFILING,
          attrs: { title: "DATA PROFILING", width: 1800 },
          scopedSlots: _vm._u([
            {
              key: "btnsRight",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "secondary" },
                      on: { click: _vm.closeMetadataProfiling },
                    },
                    [
                      _c(VIcon, { attrs: { left: "" } }, [
                        _vm._v("icon-remove"),
                      ]),
                      _vm._v("Cancelar"),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_NEW_PROFILING + "_body"
                          ].operationProfilingRule()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { left: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v("Enviar"),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-profiling", {
                ref: _vm.MODAL_NEW_PROFILING + "_body",
                attrs: {
                  tplToWork: _vm.table,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                  queryPreviousProfiling: false,
                },
                on: {
                  cancel: _vm.closeMetadataProfiling,
                  submit: _vm.onSubmitNewProfiling,
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c("DialogConfirmationComponent", {
        ref: _vm.MODAL_CONFIRM_EXECUTE_PROFILING,
        attrs: {
          title: _vm.$t("frases.execute_profiling"),
          text: _vm.$t("frases.want_profiling"),
        },
        on: { onConfirm: _vm.executeDetailSend },
      }),
      _c(
        "DialogsComponent",
        {
          ref: _vm.MODAL_PROFILING_ERROR,
          attrs: { title: _vm.$t("frases.error_profiling"), width: 800 },
        },
        [
          _c("template", { slot: "body" }, [
            _vm._v(_vm._s(_vm.$t("frases.want_error"))),
          ]),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "active",
                  on: {
                    click: function ($event) {
                      return _vm.executeErrorSend("CURRENT", "ERROR")
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-send")]),
                  _vm._v(_vm._s(_vm.$t("frases.execute_error"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.executeErrorSend("NEW", "ALL")
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-send")]),
                  _vm._v(_vm._s(_vm.$t("frases.new_execution"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }